/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_View_CountInputs */

const fr_changelog_view_count = /** @type {(inputs: Changelog_View_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vues`)
};

/**

* @param {Changelog_View_CountInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const changelog_view_count = /** @type {((inputs?: Changelog_View_CountInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_View_CountInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_changelog_view_count(inputs)
});